import { render, staticRenderFns } from "./TestList.vue?vue&type=template&id=69729905"
import script from "./TestList.vue?vue&type=script&lang=js"
export * from "./TestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports